import { setContext } from "@apollo/client/link/context";
import { useAuthStore } from "@/lib/store/auth-enhanced";

export const authContextLink = setContext((_, { headers }) => {
  // Get token from auth store
  const token = useAuthStore.getState().accessToken;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});
